import { CATEGORY, COPY_DATASET, CREATE_CATEGORY, CREATE_DATASET, CREATE_FIELD, CREATE_RELATION, DELETE_CATEGORY, DELETE_DATASET, DELETE_FIELD, EDIT_DATASET, FETCH_ALL_CATEGORIES, FETCH_ALL_DATASETS, FETCH_ALL_FIELDS, FETCH_ALL_RELATIONS, FIELD, RESTORE_FIELD, SAVE_CATEGORY, SAVE_FIELDS, SAVE_PREDEFINED_CATEGORY } from "./ActionTypes";
import { FieldManagement } from "./PropTypes";

const initialState: FieldManagement = <FieldManagement>{
    layouts: {
        _isFetching: false,
        _forceFetch: true,
        ids: [],
        entities: {}
    },
    fields: {
        _forceFetch: true,
    },
    relations: {},
    datasets: {
        _isFetching: false,
        _forceFetch: true,
        ids: [],
        entities: {},
        labels: {}
    },
};

export default function fieldmanagementReducer(state = initialState, action: any) {
    const { payload }  = action;
    switch (action.type) {
        case FETCH_ALL_DATASETS.REQUEST: 
        case CREATE_DATASET.REQUEST:
        case COPY_DATASET.REQUEST:
        case DELETE_DATASET.REQUEST:
        case EDIT_DATASET.REQUEST: {
            return {
                ...state,
                datasets: {
                    ...state.datasets,
                    _isFetching: true,
                    _forceFetch: false
                }
            }
        }
        case FETCH_ALL_DATASETS.SUCCESS: 
        case CREATE_DATASET.SUCCESS:
        case COPY_DATASET.SUCCESS:
        case DELETE_DATASET.SUCCESS:
        case EDIT_DATASET.SUCCESS: {
            const { data } = payload;
            const labels = {};
            const byId = {};
            const pathById = {};
            const loop = (children: any, path: any = []) => {
                for (const label of children) {
                    labels[label.value] = label.title;
                    const newPath = [...path, label.value];

                    if (label.children) {
                        byId[label.value] = label.children;
                        loop(label.children, newPath);
                    } else {
                        pathById[label.value] = newPath;
                    }
                }
            }

            loop(data);

            return {
                ...state,
                datasets: {
                    ...state.datasets,
                    _isFetching: false,
                    ids: data.map((item: any) => item.value),
                    entities: data,
                    labels,
                    byId,
                    pathById
                }
            };
        }

        case FETCH_ALL_FIELDS.REQUEST: {
            return {
                ...state,
                fields: {
                    ...state.fields,
                    _forceFetch: false
                }
            }
        }
        

        case FETCH_ALL_FIELDS.SUCCESS:
        case DELETE_FIELD.SUCCESS:
        case RESTORE_FIELD.SUCCESS:
        case SAVE_FIELDS.SUCCESS:
        case CREATE_FIELD.SUCCESS: {
            const { data } = payload;

            const fields: any = {};
            Object.keys(data).map((item: any) => {
                fields[item] = {
                    unsaved: {},
                    saved: data[item]
                }
            });

            return {
                ...state,
                fields
            }
        }

        case FETCH_ALL_RELATIONS.SUCCESS:
        case CREATE_RELATION.SUCCESS: {
            const { data: relations } = payload;

            return {
                ...state,
                relations
            }
        }

        case FETCH_ALL_CATEGORIES.REQUEST: {
            return {
                ...state,
                layouts: {
                    ...state.layouts,
                    _forceFetch: false
                }
            }
        }

        case CREATE_CATEGORY.SUCCESS:
        case SAVE_CATEGORY.SUCCESS:
        case SAVE_PREDEFINED_CATEGORY.SUCCESS:
        case DELETE_CATEGORY.SUCCESS: {
            // @Todo
            // API: Remove response
            // Frontend: Enable _forceFetch
            const { data } = payload;

            return {
                ...state,
                layouts: {
                    ...state.layouts,
                    _forceFetch: true,
                    entities: Object.keys(data)
                        .reduce(
                            (acc, curr) => (
                                acc[curr] = {
                                    unsaved: {},
                                    saved: data[curr]
                                },
                                acc
                            ),
                            {}
                        )
                }
            }
        }

        case FETCH_ALL_CATEGORIES.SUCCESS: {
            const { data } = payload;

            const fieldsUsedByEntityName = Object.keys(data)
                .reduce(
                    (acc, curr) => (
                        acc[curr] = Array.isArray(data[curr])
                        ? data[curr]?.reduce(
                            (a, c) => (
                                a = [...a, ...c?.fields],
                                a
                            ),
                            []
                        ).filter((value, index, self) => self.indexOf(value) === index)
                        : [],
                        acc
                    ),
                    {}
                );


            return {
                ...state,
                layouts: {
                    ...state.layouts,
                    entities: Object.keys(data)
                        .reduce(
                            (acc, curr) => (
                                acc[curr] = {
                                    unsaved: {},
                                    saved: data[curr]
                                },
                                acc
                            ),
                            {}
                        ),
                    fieldsUsedByEntityName: fieldsUsedByEntityName
                }
            }
        }

        case CATEGORY.EDIT_CATEGORY: {
            const { property, category } = payload;
            const entity = property.entity;
            const id = property.id;

            return {
                ...state,
                layouts: {
                    ...state.layouts,
                    entities: {
                        ...state.layouts.entities,
                        [entity]: {
                            ...state.layouts.entities?.[entity],
                            unsaved: {
                                ...state.layouts.entities?.[entity]?.unsaved,
                                [id]: category
                            }
                        }
                    }
                }
            }
        }

        // RESET
        case CATEGORY.RESET_CATEGORY: {
            const { property } = payload;
            const { entity, id } = property;

            const layouts: any = {
                ...state.layouts,
                entities: {
                    ...state.layouts.entities,
                    [entity]: {
                        ...state.layouts.entities?.[entity],
                        unsaved: {}
                    }
                }
            };

            return {
                ...state,
                layouts
            }
        }

        case FIELD.EDIT_FIELD: {
            const { property, field } = payload;
            const entity = property.entity;
            const id = property.id;

            const unsaved = {...state.fields[entity].unsaved[id]};
            let test = field;
            if (unsaved) {
                test = {
                    ...unsaved,
                    ...field
                }
            }

            const fields: any = {
                ...state.fields,
                [entity]: {
                    ...state.fields[entity],
                    unsaved: {
                        ...state.fields[entity].unsaved,
                        [id]: test
                    }
                }
            };

            return {
                ...state,
                fields
            }
        }

        case FIELD.RESET_FIELD: {
            const { entity } = payload;

            const fields: any = {
                ...state.fields,
                [entity]: {
                    ...state.fields[entity],
                    unsaved: {}
                }
            };

            return {
                ...state,
                fields
            }
        }

        case FETCH_ALL_DATASETS.FAILURE:
        default:
            return state;
    }
}